import { render, staticRenderFns } from "./mailWrite.vue?vue&type=template&id=6c32a7f8&scoped=true"
import script from "./mailWrite.vue?vue&type=script&lang=js"
export * from "./mailWrite.vue?vue&type=script&lang=js"
import style0 from "./mailWrite.vue?vue&type=style&index=0&id=6c32a7f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c32a7f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c32a7f8')) {
      api.createRecord('6c32a7f8', component.options)
    } else {
      api.reload('6c32a7f8', component.options)
    }
    module.hot.accept("./mailWrite.vue?vue&type=template&id=6c32a7f8&scoped=true", function () {
      api.rerender('6c32a7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/mailWrite.vue"
export default component.exports